import { cn } from 'lib/utils';
import { FC } from 'react';
import ReactMarkdown from 'react-markdown';
import styles from './BPMarkdown.module.css';

interface BPMarkdownProps {
  markdown: string;
  className?: string;
}

const BPMarkdown: FC<BPMarkdownProps> = ({ markdown, className = '' }) => (
  <div
    className={cn(
      'block relative w-full max-w-none prose prose-invert prose-blockquote:text-bionic-muted prose-blockquote:font-semiBold prose-blockquote:not-italic prose-blockquote:border-none prose-blockquote:p-0 prose-blockquote:text-[18px] md:prose-blockquote:text-[20px] lg:prose-blockquote:text-[24px] prose-strong:text-white prose-blockquote:leading-snug',
      className,
      styles.wrapper
    )}
  >
    <ReactMarkdown>{markdown}</ReactMarkdown>
  </div>
);

export default BPMarkdown;
